import { render, staticRenderFns } from "./Fa.vue?vue&type=template&id=c77fa86a&scoped=true&"
import script from "./Fa.vue?vue&type=script&lang=js&"
export * from "./Fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77fa86a",
  null
  
)

export default component.exports